import axios from "axios"

import { auth } from "@/modules/api/axios"
import { useAuthStore } from "@/modules/helpers/hooks/shared"

export enum EOcrType {
  FRONT = "FRONT",
  BACK = "BACK"
}

export interface OCRRequest {
  image: string // base64 encoded image
  type: "id_card" | "general"
}

export interface OCRResponse {
  textDetected: boolean
  text?: string[]
  confidence?: number
  error?: string
}

export const detectTextInImage = (request: OCRRequest) => {
  return auth.post<OCRResponse>(`/detect-text`, request, {
    headers: {
      "Content-Type": "application/json"
    },
    timeout: 30000 // 30 seconds timeout
  })
}

// API chung cho scan CCCD - sử dụng enum để phân biệt mặt trước/sau
export const scanIdentityCard = (file: File, type: EOcrType) => {
  const form = new FormData()
  form.append("file", file)
  form.append("type", type)

  const accessToken = useAuthStore.getState().accessToken
  return axios.post<{
    success: boolean
    data?: {
      identifyNumber?: string
      fullName?: string
      dateGrantIdentify?: string
      identifyNumberBackImage?: string
      identifyNumberFrontImage?: string
    }
    error?: string
  }>(`${import.meta.env.VITE_APP_API_HOST}/ocr/identity-card/scan`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${accessToken}`
    },
    timeout: 30000
  })
}

// API cho mặt trước CCCD - trả về số CCCD + tên
export const uploadFront = (file: File) => {
  return scanIdentityCard(file, EOcrType.FRONT)
}

// API cho mặt sau CCCD - trả về ngày cấp
export const uploadBack = (file: File) => {
  return scanIdentityCard(file, EOcrType.BACK)
}
